export const mapboxToken =
  process.env.MAPBOX_TOKEN_STATIC_PAGES || process.env.MAPBOX_TOKEN;
